var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / PA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-PA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,0 L28,9.33333333 L13.3333333,9.33333333 L13.3333333,0 L28,0 Z",
    id: "Combined-Shape",
    fill: "#E52448",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,20 L0,20 L0,9.33333333 L13.3333333,9.33333333 L13.3333333,20 Z",
    id: "Combined-Shape",
    fill: "#1367AE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-33",
    fill: "#1367AE",
    mask: "url(#mask-2)",
    points: "6.66666667 5.75999999 5.09923933 6.82404532 5.62684488 5.00452524 4.13051596 3.84262135 6.02402146 3.78214143 6.66666667 2 7.30931187 3.78214143 9.20281738 3.84262135 7.70648845 5.00452524 8.23409401 6.82404532"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-33",
    fill: "#E52448",
    mask: "url(#mask-2)",
    points: "20.6666667 15.76 19.0992393 16.8240453 19.6268449 15.0045252 18.130516 13.8426213 20.0240215 13.7821414 20.6666667 12 21.3093119 13.7821414 23.2028174 13.8426213 21.7064884 15.0045252 22.234094 16.8240453"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPa);
export default __webpack_public_path__ + "static/media/PA.73f210459db52809e80ff576773c5eb5.svg";
export { ForwardRef as ReactComponent };